const CLASSNAMES: { [key: string]: string } = {
  GRABING: 'grabbing',
  HIDE: 'u-hide',
  SCROLL_LOCK: 'scroll-lock',
  VISUALLY_HIDDEN: 'visually-hidden',
};

export default CLASSNAMES;
